var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow73(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_25874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3043 24.1592H35.2808L38.0627 21.3505L38.1995 20.1588C33.0233 15.5463 25.1216 16.0433 20.553 21.2693C19.2828 22.721 18.3613 24.4477 17.8596 26.3165C18.1695 26.1879 18.5128 26.1676 18.8361 26.2569L24.3986 25.3306C24.3986 25.3306 24.6816 24.858 24.8278 24.8878C27.3026 22.1441 31.4674 21.8245 34.3244 24.1592H34.3043Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0242 26.3162C41.3844 23.9395 40.0725 21.8025 38.247 20.168L34.3437 24.1088C35.9922 25.4685 36.9312 27.5174 36.8909 29.6666V30.3667C38.8104 30.3667 40.365 31.9376 40.365 33.8742C40.365 35.8121 38.809 37.3817 36.8909 37.3817H29.9415L29.248 38.0913V42.2989L29.9415 42.9991H36.8909C40.8747 43.0302 44.409 40.4233 45.5921 36.5827C46.7725 32.7407 45.3238 28.5697 42.0242 26.3162Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9839 42.9589H29.9333V37.3429H22.9839C22.4889 37.3429 21.9993 37.2359 21.5486 37.0273L20.5722 37.332L17.7715 40.1407L17.5273 41.1266C19.098 42.3238 21.0148 42.967 22.9839 42.9589Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9834 24.7403C19.1231 24.7633 15.7041 27.2592 14.4727 30.9522C13.2414 34.6452 14.4687 38.7214 17.5283 41.0968L21.5589 37.0273C19.8099 36.2296 19.0332 34.1522 19.8233 32.3863C20.6133 30.6204 22.6709 29.8363 24.42 30.6339C25.1899 30.986 25.8069 31.609 26.1557 32.3863L30.1864 28.3168C28.4708 26.0539 25.8056 24.7308 22.9834 24.7403Z",
    fill: "#FBBC05"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_25874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 26,
    fill: "white",
    transform: "translate(14 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow73);
export default __webpack_public_path__ + "static/media/row-7-3.d8a8b81efb3517d17042dd2ee64bc203.svg";
export { ForwardRef as ReactComponent };